import React from "react";
import FamilyDomainTaskFactory from "./FamilyDomainTaskFactory";
import LegalDomainTaskFactory from "./LegalDomainTaskFactory";
import MedicalDomainTaskFactory from "./MedicalDomainTaskFactory";
import SpiritualDomainTaskFactory from "./SpiritualDomainTaskFactory";
import { moduleTitles } from "../../Enums/TitleEnums"

interface InformationTaskFactoryProps {
  topContentRef: React.RefObject<HTMLDivElement>;
  slideKey: string;
  domain: string;
  questionCompleter: any;
}
const InformationTaskFactory: React.FC<InformationTaskFactoryProps> = (
  props
) => {
  const { slideKey, domain, questionCompleter, topContentRef } = props;

  const showCorrectSlide = () => {
    switch (domain) {
      case moduleTitles.LEGAL:
        return (
          <>
            <LegalDomainTaskFactory
              slideKey={slideKey}
              setHeader={() => { } }
              questionCompleter={questionCompleter} 
              />
          </>
        );
      case moduleTitles.MEDICAL:
        return (
          <>
            <MedicalDomainTaskFactory
              slideKey={slideKey}
              topContentRef={topContentRef}
              setHeader={() => { } }
              questionCompleter={questionCompleter} 
            />
          </>
        );
      case moduleTitles.FAMILY:
        return (
          <FamilyDomainTaskFactory
            slideKey={slideKey}
            setHeader={() => {}}
            questionCompleter={questionCompleter}
          />
        );
      case moduleTitles.SPIRITUAL:
        return (
          <SpiritualDomainTaskFactory
            slideKey={slideKey}
            setHeader={() => {}}
            questionCompleter={questionCompleter}
          />
        );
      default:
        return (
          <MedicalDomainTaskFactory
            slideKey={slideKey}
            topContentRef={topContentRef}
            setHeader={() => {}}
            questionCompleter={questionCompleter}
          />
        );
    }
  };

  return (
    <>
      {showCorrectSlide()}
    </>
  );
};

export default InformationTaskFactory;
